import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@softline/core';
import { Observable } from 'rxjs';
import { SOFTLINE_FEATURE_MODULE } from '../../application.shared';
import * as ModuleStore from '../module.store';

@Injectable()
export class ModuleInterceptor implements HttpInterceptor {
  private store: Store = inject(Store);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const active = this.store.get(SOFTLINE_FEATURE_MODULE, ModuleStore.getters.active);

    if (!active) return next.handle(request);

    request = request.clone({
      setHeaders: {
        'X-Softline-App-Module': active ?? '',
      },
    });
    return next.handle(request);
  }
}
